export const environment = {
  production: false,
  bApi: 'https://www1.analisecriminal.muralhapaulista.sp.gov.br/api/v1/',
  bRep: '/',
  bRepR10: '/',
  igb: 'https://rhsso.idp-hml.sp.gov.br/auth/realms/idpsp',
  issuer: 'https://rhsso.idp-hml.sp.gov.br/auth/realms/idpsp',
  sgbApi: 'https://govbr-service.idp-hml.sp.gov.br/userinfo/confiabilidades/detalhe',
  cgb: 'ssp.analisecriminal',
  spgb: 'Bronze;Prata;Ouro;',
  scpgb: 'openid email profile ip_address phone govbr_confiabilidades govbr_empresa',
  mlg: true,
  siteKey: '6LcXeQ8sAAAAAGl4aOmbdfRIpkj8zbK1QK78HhRT',
  clientId: 'ssp.analisecriminal',
  utilAuth: '67636215-DEEE-445A-93F4-D37114FB8633',
  envName: 'Teste',
  // === CyberArk Identity (Portal Minha Área SP) ===
  cyberArkEnabled: true,
  ica: 'https://abc4967.id.cyberark.cloud/analise_criminal_teste/',
  cca: '3af8b28a-8d5b-4a90-b664-e405241958dc',
  cyberArkMinhaArea: 'https://hml.minhaarea.sp.gov.br/plataformasp',
  periodoEleitoral: true
};

export function getEnvironment() {
  return environment;
}

export function isProduction() {
  return environment.production;
}
